module.exports = __webpack_public_path__ + "static/img/zxLogo.ca968dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/zxLogo.png
// module id = THvZ
// module chunks = 0